import i18n from '../../../../i18n';

export default {
  roleTitleWithUserCount(title: string, count: string) {
    return i18n.language === 'fa'
      ? `${title} (${count} نفر) `
      : `${title} (${count} people)`;
  },
  pureMultipleChoiceQuestion: 'تعیین نوع دسترسی سوالات',
  analysedMultipleChoiceQuestion: 'تعیین دسترسی تحلیل سوالات',
  fillAccess: 'دسترسی تکمیل سوالات بخش خود',
  reportAccess: 'دسترسی گزارش سوالات بخش خود',
};
